import React from "react";
import { Create, useForm, useSelect } from "@refinedev/antd";
import { Form, Input, Select, Radio, Card, Alert } from "antd";
import { ITaskList, IAdvert } from "../../interfaces";
import { MailOutlined, HomeOutlined, TeamOutlined } from "@ant-design/icons";

const { TextArea } = Input;
const { Option } = Select;

export const TaskListCreate: React.FC = () => {
  const { formProps, saveButtonProps } = useForm<ITaskList>();

  // Adverts für Auswahl laden
  const { selectProps: advertSelectProps } = useSelect<IAdvert>({
    resource: "senders",
    optionLabel: "title",
    optionValue: "id",
    pagination: {
      pageSize: 100,
    },
  });

  return (
    <Create saveButtonProps={saveButtonProps} title="Neue Aufgabenliste">
      <Form {...formProps} layout="vertical">
        <Card title="Grundinformationen" style={{ marginBottom: 24 }}>
          <Form.Item
            label="Titel"
            name="title"
            rules={[
              {
                required: true,
                message: "Bitte geben Sie einen Titel ein",
              },
            ]}
          >
            <Input 
              placeholder="z.B. Wöchentliche Reinigung Apartment A" 
              size="large"
            />
          </Form.Item>

          <Form.Item
            label="Beschreibung"
            name="description"
          >
            <TextArea
              rows={4}
              placeholder="Beschreiben Sie die Aufgabenliste..."
            />
          </Form.Item>
        </Card>

        <Card title="Zuweisung" style={{ marginBottom: 24 }}>
          <Form.Item
            label={
              <span>
                <MailOutlined /> Zugewiesene E-Mail-Adresse
              </span>
            }
            name="assigned_email"
            rules={[
              {
                required: true,
                message: "Bitte geben Sie eine E-Mail-Adresse ein",
              },
              {
                type: "email",
                message: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
              },
            ]}
            extra="Diese Person erhält Zugriff auf die Aufgabenliste über den Mobile-Link"
          >
            <Input 
              placeholder="reinigungskraft@beispiel.de" 
              prefix={<MailOutlined />}
            />
          </Form.Item>

          <Alert
            message="Zugriff über Mobile-Link"
            description="Nach dem Erstellen wird ein eindeutiger Link generiert, über den die zugewiesene Person ohne Login auf die Aufgabenliste zugreifen kann."
            type="info"
            showIcon
            style={{ marginBottom: 16 }}
          />
        </Card>

        <Card title="Verknüpfungen (Optional)" style={{ marginBottom: 24 }}>
          <Form.Item
            label={
              <span>
                <HomeOutlined /> Objekt/Inserat
              </span>
            }
            name="advert"
          >
            <Select
              {...advertSelectProps}
              placeholder="Objekt auswählen (optional)"
              allowClear
              showSearch
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
            />
          </Form.Item>

          <Form.Item
            label="Objektnummer"
            name="object"
            extra="Interne Objektnummer (falls vorhanden)"
          >
            <Input type="number" placeholder="z.B. 12345" />
          </Form.Item>

          <Form.Item
            label="Zimmernummer"
            name="room"
            extra="Spezifische Zimmernummer (falls zutreffend)"
          >
            <Input type="number" placeholder="z.B. 101" />
          </Form.Item>
        </Card>

        <Card title="Sichtbarkeit">
          <Form.Item
            name="visibility"
            initialValue="public"
          >
            <Radio.Group>
              <Radio value="public">
                <TeamOutlined /> Öffentlich - Für alle autorisierten Benutzer sichtbar
              </Radio>
              <Radio value="internal">
                Intern - Nur für Eigentümer und zugewiesene Person sichtbar
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Card>
      </Form>
    </Create>
  );
};